var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvcreditDebit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095581"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624127",
    width: 40,
    height: 40,
    rx: 4,
    fill: "#7DBF66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2273 12.1364V26.25C24.2273 28.9623 22.1118 31.1591 19.5 31.1591C16.8882 31.1591 14.7727 28.9623 14.7727 26.25V10.9091C14.7727 10.0954 15.084 9.31495 15.6381 8.73956C16.1922 8.16416 16.9437 7.84091 17.7273 7.84091C18.5109 7.84091 19.2624 8.16416 19.8165 8.73956C20.3705 9.31495 20.6818 10.0954 20.6818 10.9091V23.7955C20.6818 24.4705 20.15 25.0227 19.5 25.0227C18.85 25.0227 18.3182 24.4705 18.3182 23.7955V12.1364H16.5455V23.7955C16.5455 24.6092 16.8567 25.3896 17.4108 25.965C17.9649 26.5404 18.7164 26.8636 19.5 26.8636C20.2836 26.8636 21.0351 26.5404 21.5892 25.965C22.1433 25.3896 22.4545 24.6092 22.4545 23.7955V10.9091C22.4545 8.19682 20.3391 6 17.7273 6C15.1155 6 13 8.19682 13 10.9091V26.25C13 29.9809 15.9073 33 19.5 33C23.0927 33 26 29.9809 26 26.25V12.1364H24.2273Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvcreditDebit);
export default __webpack_public_path__ + "static/media/Inv credit Debit.4f61bd5379649054cb71cfa313267ef2.svg";
export { ForwardRef as ReactComponent };